export const AUTH_REQUEST=`auth/request`;
export const AUTH_SUCCESS=`auth/success`;
export const AUTH_ERROR=`auth/error`;
